var map = {
	"./-1.jpg": 594,
	"./0.jpg": 595,
	"./1.jpg": 596,
	"./10.jpg": 597,
	"./2.jpg": 598,
	"./3.jpg": 599,
	"./4.jpg": 600,
	"./5.jpg": 601,
	"./6.jpg": 602,
	"./7.jpg": 603,
	"./8.jpg": 604,
	"./9.jpg": 605,
	"./aris.jpg": 518,
	"./atamd.jpg": 519,
	"./belgeler.jpg": 520,
	"./bilge.jpg": 521,
	"./erdem.jpg": 522,
	"./hoyuk.jpg": 523,
	"./kitap.jpg": 606,
	"./tdkbelleten.jpg": 524,
	"./ttkbelleten.jpg": 525,
	"./turkdili.jpg": 526,
	"./turkdunyasi.jpg": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;